/* eslint-disable react/jsx-props-no-spreading -- every day cell takes the grid props */
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { EMPTY_DAY } from './calendarDayModel';
import type { CalendarGridProps } from './calendarGridTypes';
import { MonthDayCell } from './MonthDayCell';
import { Panel } from '../../components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The Month view (design a1): 6 rows of 7 days, Monday first. */
const MonthGridComponent: React.FC<CalendarGridProps> = ({ days, contentByDay, ...grid }) => {
  const intl = useIntl();
  const weekdays = useMemo(
    () => days.slice(0, 7).map((day) => intl.formatDate(day.start, { weekday: 'short' })),
    [days, intl]
  );

  return (
    <Panel className={styles.cal}>
      <div className={styles.dows} aria-hidden="true">
        {weekdays.map((name) => (
          <span key={name}>{name}</span>
        ))}
      </div>
      <div className={styles.mgrid} data-testid="calendar-month-grid">
        {days.map((day) => (
          <MonthDayCell key={day.key} day={day} content={contentByDay.get(day.key) ?? EMPTY_DAY} {...grid} />
        ))}
      </div>
    </Panel>
  );
};

export const MonthGrid = TypedMemo(MonthGridComponent);
